
import { useState } from 'react';

const categories = ['All Projects', 'Solar', 'HVAC', 'Insulation', 'Attic Fans'];

const projects = [
  {
    src: 'https://public.readdy.ai/ai/img_res/87970ac73b49eb684640ee9bb39dd16a.jpg',
    alt: 'Complete solar installation on Florida home',
    category: 'Solar',
    label: '12kW Solar System — Tampa, FL',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=Professional%20photograph%20of%20a%20brand%20new%20high-efficiency%20HVAC%20system%20installed%20outside%20a%20beautiful%20modern%20Florida%20home%2C%20clean%20white%20unit%20on%20concrete%20pad%2C%20neat%20copper%20piping%20tropical%20garden%20background%2C%20bright%20natural%20daylight%20commercial%20photography%20with%20warm%20tones%20and%20sharp%20detail&width=400&height=400&seq=gallery-hvac-new-001&orientation=squarish',
    alt: 'New HVAC installation',
    category: 'HVAC',
    label: '20 SEER Heat Pump — Orlando, FL',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=Professional%20photograph%20of%20a%20beautifully%20insulated%20residential%20attic%20with%20thick%20even%20layer%20of%20white%20blown-in%20insulation%2C%20bright%20work%20lights%20showing%20complete%20coverage%2C%20clean%20professional%20installation%20wooden%20trusses%20visible%20above%2C%20commercial%20photography%20with%20warm%20ambient%20lighting&width=400&height=400&seq=gallery-insul-complete-001&orientation=squarish',
    alt: 'Completed attic insulation',
    category: 'Insulation',
    label: 'R-30 Blown-In — Miami, FL',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=Professional%20photograph%20of%20a%20solar%20attic%20fan%20installed%20on%20a%20clean%20shingled%20residential%20rooftop%2C%20small%20solar%20panel%20gleaming%20in%20bright%20sunlight%2C%20neat%20professional%20installation%20with%20proper%20flashing%2C%20clear%20blue%20Florida%20sky%2C%20warm%20natural%20lighting%20commercial%20photography%20with%20vivid%20colors&width=600&height=400&seq=gallery-fan-roof-001&orientation=landscape',
    alt: 'Solar attic fan installation',
    category: 'Attic Fans',
    label: 'Pro Fan Install — Fort Myers, FL',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=Professional%20photograph%20of%20a%20happy%20homeowner%20couple%20standing%20in%20front%20of%20their%20Florida%20home%20with%20new%20solar%20panels%20visible%20on%20the%20roof%2C%20genuine%20smiles%20casual%20clothing%20lush%20tropical%20landscaping%20warm%20golden%20hour%20lighting%20lifestyle%20photography%20with%20authentic%20feel%20and%20warm%20inviting%20atmosphere&width=600&height=400&seq=gallery-solar-happy-002&orientation=landscape',
    alt: 'Happy homeowners with solar panels',
    category: 'Solar',
    label: '8kW System — Naples, FL',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=Professional%20photograph%20of%20a%20technician%20performing%20maintenance%20on%20a%20modern%20ductless%20mini-split%20indoor%20unit%20mounted%20on%20a%20wall%2C%20clean%20white%20unit%20organized%20tools%20bright%20modern%20interior%20professional%20service%20photography%20with%20warm%20natural%20lighting%20and%20sharp%20detail&width=400&height=400&seq=gallery-hvac-mini-002&orientation=squarish',
    alt: 'Mini-split installation',
    category: 'HVAC',
    label: 'Ductless Mini-Split — Sarasota, FL',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=Professional%20photograph%20of%20a%20technician%20using%20a%20thermal%20imaging%20camera%20to%20inspect%20attic%20insulation%20in%20a%20residential%20home%2C%20colorful%20thermal%20image%20visible%20on%20the%20camera%20screen%20showing%20heat%20patterns%20professional%20inspection%20equipment%20commercial%20photography%20with%20warm%20lighting&width=400&height=400&seq=gallery-insul-thermal-002&orientation=squarish',
    alt: 'Thermal inspection of insulation',
    category: 'Insulation',
    label: 'Thermal Audit — Jacksonville, FL',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=Professional%20photograph%20of%20multiple%20solar%20attic%20fans%20installed%20on%20a%20large%20commercial%20building%20rooftop%2C%20several%20units%20in%20a%20row%20with%20solar%20panels%20gleaming%2C%20industrial%20roofing%20material%20clear%20blue%20sky%20professional%20commercial%20photography%20with%20sharp%20detail%20and%20warm%20natural%20lighting&width=600&height=400&seq=gallery-fan-commercial-002&orientation=landscape',
    alt: 'Commercial solar fan installation',
    category: 'Attic Fans',
    label: 'Commercial Install — Clearwater, FL',
  },
];

export default function ProjectGallery() {
  const [activeFilter, setActiveFilter] = useState('All Projects');

  const filtered =
    activeFilter === 'All Projects'
      ? projects
      : projects.filter((p) => p.category === activeFilter);

  return (
    <section className="py-24 bg-brand-sand">
      <div className="max-w-[1400px] mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Our Recent Projects
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Browse real installations from Florida homeowners who are now saving
            thousands on energy costs every year.
          </p>
        </div>

        {/* Filter buttons */}
        <div className="flex flex-wrap justify-center gap-3 mb-12">
          {categories.map((cat) => (
            <button
              key={cat}
              onClick={() => setActiveFilter(cat)}
              className={`px-5 py-2.5 rounded-full text-sm font-semibold transition-all duration-300 cursor-pointer whitespace-nowrap ${
                activeFilter === cat
                  ? 'bg-brand-navy text-white shadow-lg'
                  : 'bg-white text-gray-700 hover:bg-gray-100 border border-gray-200'
              }`}
            >
              {cat}
            </button>
          ))}
        </div>

        {/* Gallery grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {filtered.map((project, i) => (
            <div
              key={`${project.alt}-${i}`}
              className={`relative rounded-2xl overflow-hidden group cursor-pointer ${
                i === 0 || i === 4 ? 'lg:col-span-2' : ''
              }`}
            >
              <img
                src={project.src}
                alt={project.alt}
                className={`w-full object-cover object-top group-hover:scale-110 transition-transform duration-700 ${
                  i === 0 || i === 4 ? 'h-[320px]' : 'h-[320px]'
                }`}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5 translate-y-4 group-hover:translate-y-0 opacity-0 group-hover:opacity-100 transition-all duration-300">
                <span className="inline-block bg-brand-red text-white text-xs font-bold px-3 py-1 rounded-full mb-2 whitespace-nowrap">
                  {project.category}
                </span>
                <p className="text-white font-semibold text-sm">{project.label}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
